import { createSlice } from '@reduxjs/toolkit';
import { loginThunk, signUpThunk } from '../thunks/authThunk';
import { getAlaCartItemDetailsThunk, getAllCategoriesVendorsThunk, getAllCategoryListThunk, getfavouriteListThunk, getFilteredVendorThunk, getMenuItemsListThunk, getPackageDetailsThunk, getpackageItemsListThunk, getTotalVendorCountThunk, getVendorAvailabilityDetailsThunk, getVendorDetailsThunk, getVendorsbyCategoryIdThunk, searchInAllCategoryThunk } from '../thunks/vendorThunk';


const vendorSlice = createSlice({
  name: 'auth',
  initialState: {
    vendor: "",
    allVendors: "",
    categoryList: "",
    menuItemsList: "",
    packageItemsList: '',
    vendorsbyCategoryId: "",
    totatVendorsCount: "",
    package: '',
    alaCartItem: '',
    getVendorAvailabilityDetails: '',
    favouriteVendorList: '',
    filterCustomizations: '',
    filteredVendor: '',
    searchedAllVendorsList: ''
  },
  reducers: {
    setVendorFilterCustomization: (state, action) => {
      state.filterCustomizations = action.payload;
    },
    clearVendorFilterCustomization: (state, action) => {
      state.filterCustomizations = '';
      state.filteredVendor = '';
    },
    clearSearchAllVendors: (state, action) => {
      state.searchedAllVendorsList = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategoriesVendorsThunk.fulfilled, (state, action) => {
        state.allVendors = action.payload?.data;
      })
      .addCase(getVendorsbyCategoryIdThunk.fulfilled, (state, action) => {
        state.vendorsbyCategoryId = action.payload?.data;
      })
      .addCase(getAllCategoryListThunk.fulfilled, (state, action) => {
        state.categoryList = action.payload?.data;
      })
      .addCase(getTotalVendorCountThunk.fulfilled, (state, action) => {
        state.totatVendorsCount = action.payload?.data;
      })
      .addCase(getVendorDetailsThunk.fulfilled, (state, action) => {
        state.vendor = action.payload?.data?.vendorDetails;
        state.packageItemsList = action.payload?.data?.packages;
        state.menuItemsList = action.payload?.data?.alacarteitems;
      })
      .addCase(getPackageDetailsThunk.fulfilled, (state, action) => {
        state.package = action.payload?.data;
      })
      .addCase(getAlaCartItemDetailsThunk.fulfilled, (state, action) => {
        state.alaCartItem = action.payload?.data;
      })
      .addCase(getVendorAvailabilityDetailsThunk.fulfilled, (state, action) => {
        state.getVendorAvailabilityDetails = action.payload?.data;
      })
      .addCase(getfavouriteListThunk.fulfilled, (state, action) => {
        state.favouriteVendorList = action.payload?.data;
      })
      .addCase(getFilteredVendorThunk.fulfilled, (state, action) => {
        state.filteredVendor = action.payload?.data;
      })
      .addCase(searchInAllCategoryThunk.fulfilled, (state, action) => {
        state.searchedAllVendorsList = action.payload?.data;
      })
      .addCase(getMenuItemsListThunk.fulfilled, (state, action) => {
        state.menuItemsList = action.payload?.data;
      })
      .addCase(getpackageItemsListThunk.fulfilled, (state, action) => {
        state.packageItemsList = action.payload?.data;
      })
  },
});

export const { setVendorFilterCustomization, clearVendorFilterCustomization, clearSearchAllVendors } = vendorSlice.actions;

export default vendorSlice.reducer;
